export default __webpack_public_path__ + "static/media/male.8046e0e0.png";